<template>
  <div
    class="card border border-dark border-2 rounded rounded-5 h-100 shadow-sm position-relative"
    :class="{
      'text-muted opacity-50': !achievement.isEarned && isDimmed
    }"
  >
    <!-- Replace with StarIcon -->
    <div
      class="position-absolute top-0 start-100 translate-middle d-flex align-items-center justify-content-center"
      style="width: 2.5rem; height: 2.5rem"
      title="Points"
    >
      <i
        class="bi bi-star-fill text-warning position-absolute"
        style="font-size: 3rem; line-height: 1; transform: translateX(-2px)"
      ></i>

      <span
        class="position-relative text-dark fw-bold"
        style="font-size: 1.3rem; transform: translate(-2px, 1.5px)"
      >
        {{ achievement.points }}
      </span>
    </div>
    <div class="card-body">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center text-start">
          <div class="fs-1 me-3">
            <i class="bi" :class="achievement.icon"></i>
            <img :src="achievement.icon" width="50px" />
          </div>
          <div>
            <div class="fw-bold">{{ achievement.name }}</div>
            <div>{{ achievement.description }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer" v-if="!hideCardFooter">
      <div class="row align-items-center">
        <div class="col" v-if="showUsers">
          <div class="position-relative">
            <div
              v-for="(member, index) in membersWithAchievement"
              :key="member.id"
            >
              <div
                class="position-absolute"
                :style="[`margin-left: ${index * PORTRAIT_OFFSET}px`]"
              >
                <UserProfile
                  v-bind="member"
                  :size="PORTRAIT_SIZE"
                  fontSize=".5"
                />
              </div>
            </div>
            <!-- show +X if there are more -->
            <div
              v-if="membersWithAchievement.length > MAX_ICONS_VISIBLE"
              class="position-absolute fw-bold badge bg-crater border border-2 border-dark rounded-pill"
              :style="[
                `margin-left: ${MAX_ICONS_VISIBLE * PORTRAIT_OFFSET}px`,
                `width: ${PORTRAIT_SIZE}px`,
                `height: ${PORTRAIT_SIZE}px`
              ]"
            >
              <div class="fs-5 pt-1">
                <div>
                  +{{ membersWithAchievement.length - MAX_ICONS_VISIBLE }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col text-end text-small">
          <div v-if="achievement.isEarned" class="text-end text-muted">
            Earned {{ achievement.formattedDate }}
          </div>
          <div v-else class="text-nowrap">
            {{ achievement.codesEarned }} /
            {{ achievement.codes.length }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* https://vuejs.org/guide/essentials/lifecycle.html#lifecycle-diagram */
const MAX_ICONS_VISIBLE = 2; // Maximum number of user icons to display per badge
const PORTRAIT_OFFSET = 30; // pixels.
const PORTRAIT_SIZE = 40; // pixels.
import { mapGetters } from "vuex";

import UserProfile from "@/components/activity/UserProfile.vue";
export default {
  name: "AchievementBadge",
  components: { UserProfile },
  data() {
    return {
      MAX_ICONS_VISIBLE,
      PORTRAIT_OFFSET,
      PORTRAIT_SIZE
    };
  },
  props: {
    achievement: {
      type: Object,
      required: true
    },
    showUsers: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("datastore", ["getEntry"]),
    ...mapGetters("groups", ["getMyMappedGroup"]),
    // This is used to determine if the badge should be dimmed
    isDimmed() {
      return this.$route.meta.isDimmed === true;
    },
    hideCardFooter() {
      return this.$route.meta.hideCardFooter === true;
    },
    // Filter members of the group who have earned the achievement
    membersWithAchievement() {
      // let members = this.getMyMappedGroup.members.filter(
      //   (member) =>
      //     Array.isArray(member.codes) &&
      //     member.codes.some(
      //       (code) =>
      //         this.achievement.codes.includes(code.code) &&
      //         code.score >= this.achievement.targetScore
      //     )
      // );
      if (!this.getMyMappedGroup) {
        return [];
      }

      let members = this.getMyMappedGroup.members.filter((member) => {
        if (!Array.isArray(member.codes)) {
          return false;
        }

        // Collect all codes the member has where score >= targetScore
        const earnedCodes = new Set(
          member.codes
            .filter((c) => c.score >= this.achievement.targetScore)
            .map((c) => c.code)
        );

        // Count how many number of codes the user has earned that are part of this achievement
        const numberOfCodesEarned = this.achievement.codes.filter((code) =>
          earnedCodes.has(code)
        ).length;

        // User has earned the achievement if they have all required codes
        return numberOfCodesEarned === this.achievement.codes.length;
      });

      members = members.filter(
        (member) => member.userId !== this.getEntry.userId
      );

      members = members.slice(0, MAX_ICONS_VISIBLE);
      return members;
    }
  },
  methods: {}
  /* lifecycle hooks */
};
</script>

<style scoped>
.text-small {
  font-size: 0.8rem;
}

.extra {
  width: 40px;
  height: 40px;
}
</style>
